import { get, post, put, del, search } from 'redux/shelf/api';
import session from 'lib/session';
import { createReducer, field } from 'redux/shelf';

export const actions = {
  fetch: get`translation/${session.getMerchant}`(),
  update: put`translation/${session.getMerchant}`(),
  fetchLanguages: get`languages`(field('languages')),
  updateFeLanguage: put`settings/frontend/language`(),
};

export const reducer = createReducer(actions);
